import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';


const FaqSection = (props) => {

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div className="wpo-benefits-section">
            <div className="row">
                <div className="col-lg-12 col-12">
                   <div className="wpo-benefits-item">
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography>How do I start a legal case with your firm?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    To begin, you can contact our offices to schedule an initial consultation. 
                                    During this meeting, we assess your matter, review any documents you provide, 
                                    and advise you on the best legal strategy. Once you formally instruct us, 
                                    we begin preparing your case immediately.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                            >
                                <Typography>What should I expect during the first consultation?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Your lawyer will gather background information, review the facts of your matter, 
                                    outline possible legal options, and explain the costs involved. This meeting is confidential 
                                    and designed to give you clarity on the legal steps ahead.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography>Who will handle my case?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Your matter will be managed by an experienced attorney within our firm, 
                                    supported by our legal clerks and administrative team. We ensure that 
                                    all clients receive professional attention and timely updates.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                            >
                                <Typography>How long will my case take to resolve?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Timeframes differ depending on the type of matter—civil, criminal, commercial, 
                                    or property-related. We will advise you of expected timelines after reviewing your case, 
                                    and we keep you updated throughout the entire process.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel5bh-content"
                                id="panel5bh-header"
                            >
                                <Typography>Is there a deadline for filing a claim or lawsuit?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Yes. Most legal matters in Zimbabwe have specific prescription periods (deadlines). 
                                    Delaying your case may affect your ability to obtain a remedy. Contact us as soon 
                                    as possible so we can advise you on the relevant timelines for your matter.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FaqSection;